import { render, staticRenderFns } from "./PropertyAgreementList.vue?vue&type=template&id=cac01b98&"
import script from "./PropertyAgreementList.vue?vue&type=script&lang=js&"
export * from "./PropertyAgreementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
